import SignupUser from '../components/presentations/signupUser'
import { clearToken } from '../hooks/useStorageApp'

const SignUpContainer = () => {
  clearToken()
  return <SignupUser />
}

export default SignUpContainer
